export default __webpack_public_path__ + "static/media/電表2.4f6769a8.gif";